<style scoped></style>

<template>
  <div class="hero has-text-centered">
    <div class="hero-body  animated zoomIn">

      <b-icon icon="block" size="is-large"/>

      <h1 class="title m-t-md"><b>403</b></h1>
      <h3 class="subtitle">Acesso Negado!</h3>

      <p class="m-t-md">
        Ops! Você não possui acesso à esse recurso. <br/>
        Você pode voltar para a página principal.
      </p>

      <router-link to="/" class="button m-t-md">
        <b-icon icon="home"/>
        <span>Voltar</span>
      </router-link>

    </div>
  </div>
</template>

<script>
  export default {}
</script>



// WEBPACK FOOTER //
// src/components/403.vue